<template>
  <div id="app">
    <div class="fixed_box">
      <div class="d-f f-ai-c f-jc-c c-p" @click="handleClickTitle('扫码下载')">
        <img src="@/assets/images/index/icon12.png" alt="" />
        <p>扫码下载</p>
      </div>
      <div class="d-f f-ai-c f-jc-c c-p" @click="handleClickTitle('客服二维码')">
        <img src="@/assets/images/index/icon13.png" alt="" />
        <p>客服二维码</p>
      </div>
      <div class="d-f f-ai-c f-jc-c c-p" @click="handleClickTitle('课程选购')">
        <img src="@/assets/images/index/icon14.png" alt="" />
        <p>课程选购</p>
      </div>
    </div>

    <!-- 扫码下载弹框 -->
    <div class="pos_f_box_down d-f f-ai-c f-jc-c" v-show="isShowDownPop" @click.stop="closePop()" >
      <img src="@/assets/images/index/pop_img_1.png" alt="" />
    </div>
    <!-- 客服二维码弹框 -->
    <div class="pos_f_box_service d-f f-ai-c f-jc-c" v-show="isShowServicePop" @click.stop="closePop()">
      <img src="@/assets/images/index/pop_img_2.png" alt="" />
    </div>

    <div v-if="showIndex">
      <!-- 首页 -->
      <Index @getHandleSelect="getHandleSelect" />
    </div>
    <div v-else>
      <div class="header d-f f-ai-c f-jc-sa">
        <div class="logo_img" @click="logoClick">
            <div class="header-logo">
              <img id="header-img" src="@/assets/images/menu/menuLogo.png" />
            </div>
        </div>
        <div id="menu_index" class="d-f f-jc-c">
          <!-- web端菜单导航 -->
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo d-f f-ai-c"
            menu-trigger="click"
            text-color="#333"
            style="height: 4.1667vw; border: 0"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              v-for="item in menuList"
              :key="item.key"
              :index="item.key"
              :class="[
                ...item.className,
                activeIndex == item.key ? `active_color${activeIndex}` : '',
                'd-f f-ai-c f-jc-c',
              ]"
            >
              <img class="mg-r-10" :src="item.imgUrl" alt="" />
              {{ item.name }}
            </el-menu-item>
          </el-menu>
        </div>
        <div>
          <el-button v-if="!isLogin" type="text" class="login_btn d-f f-ai-c f-jc-c" @click="login">登录</el-button>
          <el-dropdown v-else trigger="click">
            <div class="login_btn login_btn_active c-p d-f f-ai-c f-jc-c">
              <el-tooltip effect="dark" :content="userName" placement="right-start">
                <div class="d-f f-ai-c f-jc-c">
                  <div class="toop_list overflow-1">{{userName}}</div>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
              </el-tooltip>
            </div>
            <el-dropdown-menu slot="dropdown" class="dropdown_box">
              <el-dropdown-item>
                <div class="d-f f-ai-c f-jc-c" @click="logOut()"><i class="iconfont icon-tuichu"></i>退出登录</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      
      <!-- 登录弹框 -->
      <div v-if="isShowLoginPop" class="pos_f_box_login d-f f-ai-c f-jc-c">
        <div class="content d-f f-f-c f-ai-c">
          <div class="close_icon c-p" @click="isShowLoginPop=false"><i class="el-icon-close"></i></div>
          <div class="title">教师登录</div>
          <div class="table_box">
            <div class="table_item mg-b-40">
              <div class="d-f f-ai-c">
                <i class="el-icon-mobile-phone"></i>
                <el-input el-input v-model="phoneVal" maxlength="11" placeholder="请输入手机号码"></el-input>
              </div>
            </div>
            <div class="table_item">
              <div class="d-f f-ai-c">
                <i class="el-icon-lock"></i>
                <el-input v-model="passWordVal" placeholder="请输入密码" show-password></el-input>
              </div>
            </div>
          </div>
          <div class="btn d-f f-ai-c f-jc-c c-p" @click="submitLogin">立即登录</div>
          <div class="desc mg-t-30 d-f d-ai-c f-jc-c">没有账户或忘记密码？请联系<span>网站管理员</span></div>
        </div>
      </div>

      <div class="container" style="clear: both">
        <router-view></router-view>
      </div>
    </div>

    <div class="bottom_box">
      <img class="bottom_box_img" src="@/assets/images/index/bottom_bg.png" alt="">
      <div class="bottom_content d-f f-ai-c f-jc-sb">
        <div class="bottom_menu">
          <div class="bottom_img">
            <img src="@/assets/images/index/logo.png" alt="" />
          </div>
          <div class="mg-t-20 d-f f-ai-c f-jc-sb">
            <div
              class="bottom_menu_desc d-f f-ai-c f-jc-c c-p"
              v-for="item in menuList"
              :key="item.key"
              :index="item.key"
              @click="handleSelect(item.key)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="bottom_text mg-t-30">
            <p class="mg-t-10" ><span class="c-p" @click="jumpPath">粤ICP备20068012号-1</span></p>
            <p class="mg-t-10">©版权所有：广州市爱思通文化教育科技有限公司</p>
            <p class="mg-t-10">联系地址：广州市黄埔区伴河路190号自编A栋303房</p>
          </div>
        </div>
        <div class="bottom_service">
          <div class="bottom_service_bgc">
            <img src="@/assets/images/index/icon2.png" alt="" />
          </div>
          <div class="bottom_service_phone d-f f-ai-c f-jc-sb">
            <div class="c-p" @click="handleClickTitle('微信公众号')">
              <img src="@/assets/images/index/icon1.png" alt="" />
              <div class="mg-t-5">微信公众号</div>
            </div>
            <div class="c-p" @click="handleClickTitle('爱思通抖音号')">
              <img src="@/assets/images/index/icon1.png" alt="" />
              <div class="mg-t-5">爱思通抖音号</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pos_f_box_bottom d-f f-ai-c f-jc-c" v-show="isShowWeiXinPop" @click.stop="closePop()">
      <img src="@/assets/images/index/pop_img_3.jpg" alt="" />
    </div>
    <div class="pos_f_box_bottom d-f f-ai-c f-jc-c" v-show="isShowDouYinPop" @click.stop="closePop()">
      <img src="@/assets/images/index/pop_img_4.jpg" alt="" />
    </div>

    <div id="back_to_top" ref="btn" @click="backTop" v-show="backTopShow">
      <div class="back_top_box d-f f-f-c f-jc-sb f-ai-c">
        <img src="@/assets/images/index/icon15.png" alt="" />
        <div>返回顶部</div>
      </div>
    </div>
  </div>
</template>

<script>
import Index from "@/views/Index.vue";
import { TeacherLogin } from '@/utils/commonApi'
export default {
  name: "App",
  components: {
    Index,
  },
  data() {
    return {
      isLogin: false,  // 是否登录
      isShowLoginPop: false,  // 打开登录弹窗
      phoneVal: '',  // 手机号
      passWordVal: '',  // 密码
      userName: '',  // 登录用户名
      activeIndex: "",   // web端菜单导航
      showIndex: false,
      isShowDownPop: false, // 是否展示扫码下载二维码
      isShowServicePop: false, // 是否展示客服二维码
      isShowWeiXinPop: false, // 是否展示微信公众号二维码
      isShowDouYinPop: false, // 是否展示抖音二维码
      backTopShow: false, // 回到顶部
      // scroll: '',
      // timer: '',
      // seen: true,
      menuList: [
        {
          name: "首页",
          key: "1",
          className: ["header-title", "color1"],
          imgUrl: require("@/assets/images/menu/menu1.png"),
        },
        {
          name: "关于我们",
          key: "2",
          className: ["header-title", "color2"],
          imgUrl: require("@/assets/images/menu/menu2.png"),
        },
        {
          name: "软件下载",
          key: "3",
          className: ["header-title", "color3"],
          imgUrl: require("@/assets/images/menu/menu3.png"),
        },
        {
          name: "爱宝商城",
          key: "4",
          className: ["header-title", "color4"],
          imgUrl: require("@/assets/images/menu/menu4.png"),
        },
        {
          name: "教学平台",
          key: "5",
          className: ["header-title", "color5"],
          imgUrl: require("@/assets/images/menu/menu5.png"),
        },
        {
          name: "合作加盟",
          key: "6",
          className: ["header-title", "color6"],
          imgUrl: require("@/assets/images/menu/menu6.png"),
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      // 路由变化
      this.Move();
      this.showIndex = false;
      switch (to.path) {
        case "/":
          this.activeIndex = "1";
          this.showIndex = true;
          break;
        case "/AboutUs":
          this.activeIndex = "2";
          break;
        case "/SoftwareDownload":
          this.activeIndex = "3";
          break;
        case "/AbroStore":
          this.activeIndex = "4";
          break;
        case "/AbroClassroom":
          this.activeIndex = "5";
          break;
        case "/JoinIn":
          this.activeIndex = "6";
          break;
        default:
          this.activeIndex = "";
          break;
      }
    },
    // 滚轮停止-开启
    isShowDownPop(newVal, oldVal) {
      if (newVal) {
        this.stopMove();
      } else {
        this.Move();
      }
    },
    // 滚轮停止-开启
    isShowServicePop(newVal, oldVal) {
      if (newVal) {
        this.stopMove();
      } else {
        this.Move();
      }
    },
    // 滚轮停止-开启
    isShowLoginPop(newVal, oldVal) {
      if (newVal) {
        this.stopMove();
      } else {
        this.Move();
      }
    },
    // 滚轮停止-开启
    isShowWeiXinPop(newVal, oldVal) {
      if (newVal) {
        this.stopMove();
      } else {
        this.Move();
      }
    },
    // 滚轮停止-开启
    isShowDouYinPop(newVal, oldVal) {
      if (newVal) {
        this.stopMove();
      } else {
        this.Move();
      }
    },
    // 登录弹框关闭
    isShowLoginPop(newVal, oldVal) {
      if(!newVal) {
        this.phoneVal = ''
        this.passWordVal = ''
      }
    }
  },
  mounted() {
    this.isLogin = sessionStorage.getItem("token") ? true:false
    this.userName = sessionStorage.getItem("userName") || ''
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 400) {
        //判断滚动后高度超过,就显示
        this.backTopShow = true
      } else {
        this.backTopShow = false
      }
    },

    backTop() {
      //当点击标签的时候,滚到顶部
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 0);
    },

    // 获取子组件点击事件
    getHandleSelect(e) {
      this.handleSelect(e);
    },

    // 菜单选择
    handleSelect(key) {
      // 路由相同不做跳转
      if(key === this.activeIndex) {
        this.$router.go(0)
      }
      switch (key) {
        case "1":
          this.$router.push({ path: "/" });
          this.activeIndex = "1";
          break;
        case "2":
          this.activeIndex = "2";
          this.$router.push({ path: "/AboutUs" });
          break;
        case "3":
          this.activeIndex = "3";
          this.$router.push({ path: "/SoftwareDownload" });
          break;
        case "4":
          this.activeIndex = "4";
          this.$router.push({ path: "/AbroStore" });
          break;
        case "5":
          this.activeIndex = "5";
          this.$router.push({ path: "/AbroClassroom" });
          break;
        case "6":
          this.activeIndex = "6";
          this.$router.push({ path: "/JoinIn" });
          break;
        default:
          this.activeIndex = "";
          break;
      }
    },
    // 登录
    login() {
      this.isShowLoginPop = true
    },
    
    // 确定登录
    submitLogin() {
      let result = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phoneVal)
      if(!this.phoneVal) {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
      } else if(!this.passWordVal) {
        this.$message({
          message: '请输入密码',
          type: 'error'
        });
        return
      } else if(!result) {
        this.$message({
          message: '请输入正确的手机号码格式',
          type: 'error'
        })
        return
      } else {
        // axios 请求
        let params = {
          account: this.phoneVal,
          password: this.passWordVal,
        }
        TeacherLogin(params).then(res => {
          if(res.code === "OK") {
            sessionStorage.setItem('token', `${res.content.token_Type} ${res.content.access_Token}`)
            sessionStorage.setItem('userName', res.content.name)
            this.userName = res.content.name
            this.isLogin = true
            this.isShowLoginPop = false
            window.location.reload()
          }
        })
      }
     
    },
    
    // 退出
    logOut() {
      sessionStorage.removeItem("token")
      sessionStorage.removeItem("userName")
      this.isLogin = false
      window.location.reload()
    },

    // 点击logo
    logoClick() {
      this.$router.push({ path: "/" });
      this.activeIndex = "1";
    },

    // 右上角三个标题点击
    handleClickTitle(value) {
      switch (value) {
        case "扫码下载":
          this.isShowDownPop = true;
          break;
        case "客服二维码":
            this.isShowServicePop = true
          break;
        case "课程选购":
          if(this.$route.path === '/AbroStore') {
            this.$router.go(0)
          } else {
            this.$router.push("/AbroStore");
          }
          break;
        case '微信公众号':
          this.isShowWeiXinPop = true
          break;
        case '爱思通抖音号':
          this.isShowDouYinPop = true
          break;
      }
    },
    // 停止滚动
    stopMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); //禁止页面滑动
    },
    //开启页面滚动
    Move() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },

    // 关闭弹框
    closePop() {
      this.isShowDownPop = false;
      this.isShowServicePop = false;
      this.isShowWeiXinPop = false;
      this.isShowDouYinPop = false;
      this.Move();
    },

    jumpPath() {
      window.open("https://beian.miit.gov.cn", "_blank")
    }
  },
};
</script>

<style scoped lang="less">
.color1 {
  color: rgb(238, 45, 0) !important;
}
.color2 {
  color: rgb(240, 128, 0) !important;
}
.color3 {
  color: rgb(170, 204, 0) !important;
}
.color4 {
  color: rgb(20, 130, 200) !important;
}
.color5 {
  color: rgb(54, 150, 173) !important;
}
.color6 {
  color: rgb(201, 79, 152) !important;
}
.active_color1 {
  border-bottom: 0.1042vw solid rgb(238, 45, 0) !important;
}
.active_color2 {
  border-bottom: 0.1042vw solid rgb(240, 128, 0) !important;
}
.active_color3 {
  border-bottom: 0.1042vw solid rgb(170, 204, 0) !important;
}
.active_color4 {
  border-bottom: 0.1042vw solid rgb(20, 130, 200) !important;
}
.active_color5 {
  border-bottom: 0.1042vw solid rgb(54, 150, 173) !important;
}
.active_color6 {
  border-bottom: 0.1042vw solid rgb(201, 79, 152) !important;
}

#app {
  position: relative;
}

.logo_img {
  /* float:left;
    width: 30%; */
  cursor: pointer;
}
#back_to_top {
  position: fixed;
  bottom: 2.8646vw;
  right: 1.4583vw;
  cursor: pointer;
}
.back_top_box {
  height: 5.2083vw;
  width: 4.1667vw;
  background: #fff;
  padding: 0.6771vw 0 0.6771vw 0;
  box-sizing: border-box;
  border-radius: 0.4167vw;
  font-size: 0.7292vw;
  img {
    width: 2.5vw;
    height: 2.5vw;
  }
}
.header-title {
  font-size: 0.8333vw;
  font-weight: 600;
  width: 5.7292vw;
  margin: 0 0.7813vw;
  img {
    height: 1.6667vw;
    width: 1.6667vw;
  }
}
.company_name {
  font-weight: normal;
  font-size: 1em;
}
.footer_font {
  font-size: 1em;
}
#menu_index {
  float: left;
  min-width: 50vw;
  height: 100%;
}
.header {
  margin: auto;
  width: 64.5833vw;
  height: 4.1667vw;
  /*background: #F56C6C;*/
  /deep/.el-menu-demo {
    .el-menu-item {
      height: 4.1667vw !important;
    }
  }
}
@media screen and (max-device-width: 21.6146vw) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }
  #back_to_top {
    position: fixed;
    bottom: 2.8646vw;
    right: 1.4583vw;
    cursor: pointer;
  }
  .footer_font {
    font-size: 0.875em;
  }
  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }
  /* .mobile_menu{

    } */
}
#header-img {
  height: 2.8646vw;
  width: 7.6563vw;
  float: left;
  margin: auto;
}

.footer {
  display: flex;
  align-items: center;
  margin: 0.5208vw auto;
  width: 90%;
}
a {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}

.pos_f_box_down, .pos_f_box_service, .pos_f_box_login, .pos_f_box_bottom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 299;
  background: rgba(0, 0, 0, 0.6);
  img {
    width: 13.4375vw;
    height: 13.4375vw;
  }
}

.pos_f_box_login {
  .content {
    width: 29.7917vw;
    height: 31.8229vw;
    border-radius: 0.5208vw;
    background: #fff;
    position: relative;
    .close_icon {
      position: absolute;
      top: 1.5104vw;
      right: 1.5104vw;
      i {
        font-size: 1.5625vw;
        color: #707070;
      }
    }
    .title {
      margin-top: 3.75vw;
      font-size:1.875vw;
      font-weight:700;
      line-height: 2.4479vw;
    }
    .table_box {
      width: 21.9792vw;
      margin-top: 4.4271vw;
      .table_item {
        padding-bottom: 0.9375vw;
        border-bottom: 0.0521vw solid #707070;
        i {
          font-size: 1.4583vw;
          margin-right: 0.6771vw;
        }
        /deep/.el-input {
          width: 19.7917vw;
          font-size: 0.8333vw;
          input {
            padding: 0 !important;
            border: none !important;
          }
        }
      }
    }
    .btn {
      width: 17.7083vw;
      height: 3.75vw;
      font-size: 1.25vw;
      color: #ffffff;
      background-color:#abcd02;
      border-radius: 2.6042vw;
      margin-top: 3.75vw;
    }
    .desc {
      font-size: 0.9375vw;
      line-height: 1.25vw;
      span {
        color: #00A0E9;
      }
    }
  } 
}

.login_btn {
  height: 1.7708vw;
  width: 4.1667vw;
  font-size: 0.7292vw;
  border: 0.0521vw solid orange;
  color: orange;
  border-radius: 0.8854vw;
  box-sizing: border-box;
  .toop_list {
    width: 39px !important;
  }
}
.login_btn_active {
  padding: 0 0.5208vw;
  color: #fff;
  background: orange;
  box-sizing: border-box;
}
::v-deep.dropdown_box {
    padding: 0 !important;
}

.active_menu {
  border-bottom: 0.1042vw solid yellow !important;
}

.bottom_box {
  width: 100vw;
  height: 19.2708vw;
  // background: url("@/assets/images/index/bottom_bg.png");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  position: relative;
  .bottom_box_img {
    position: absolute;
    width: 100vw;
    height: 19.2708vw;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  .bottom_content {
    width: 64.5833vw;
    margin: 0 auto;
    padding-top: 2.8646vw;
    box-sizing: border-box;
    .bottom_menu {
      width: 40.1042vw;
      .bottom_img {
        width: 13.3854vw;
        height: 5vw;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .bottom_menu_desc {
        width: 6.25vw;
        height: 1.7708vw;
        background: #5c5c5c;
        border-radius: 0.8854vw;
        color: #fff;
        font-size: 0.8333vw;
      }
      .bottom_text {
        p {
          font-size: 0.7292vw;
          color: #fff;
        }
      }
    }

    .bottom_service {
      width: 14.7917vw;
      .bottom_service_bgc {
        width: 100%;
        height: 8.9063vw;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .bottom_service_phone {
        width: 10.9375vw;
        margin: 0 auto;
        color: #fff;
        padding-top: 1.5625vw;
        font-size: 0.8333vw;
        img {
          width: 2.5vw;
          height: 2.5vw;
          margin: 0 auto;
        }
      }
    }
    // 255 95
  }
}

.fixed_box {
  z-index: 199;
  position: absolute;
  top: 5.3646vw;
  right: 0;
  font-size: 0.7292vw;
  div {
    width: 7.6042vw;
    height: 2.3438vw;
    margin-bottom: 1.0417vw;
    background: #fff;
    position: relative;
    border-bottom-left-radius: 0.3125vw;
    border-top-left-radius: 0.3125vw;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 2.3438vw;
      height: 2.3438vw;
      z-index: 199;
    }
    p {
      margin-left: 2.3438vw;
    }
  }
}
</style>
